// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"76d57d50","508":"0e1467e2","584":"95fd768c","679":"cdfe28a1","729":"17b17aa1","763":"68857348","848":"f323e3ee","941":"f2b991a6"}[chunkId] + ".chunk.css";
};